import React from "react";
import _ from "lodash";
import moment from "moment";
import Img from "react-image";
import {
  postArriveSimple,
  updateArriveEvent,
  deleteArriveEvent,
} from "../les-tabs-ducks/Arrive.ducks";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import { connect } from "react-redux";
import Classnames from "classnames";
import { withTranslation } from 'react-i18next';
import ModalTreatement from "./ModalTreatement";
import { Service } from "../../../../../service/service";
import { API } from "../../../../../../const";
import { TimePickerCustom } from "../../../../../../components";

moment.locale("fr");
function notEmpty(value) {
  return !_.isEmpty(value);
}

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;
class Arrivee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accompagantDepart: "string",
      etatRepas: "",
      etatSommeil: "",
      etatSante: "",
      idParent: 0,
      idTierceAutorise: 0,
      observation: "string",
      timeArrivee: moment(),
      listOfParents: [],
      selectedParent: {},
      isOpen: true,
      initialized: false,
      traitement: "",
      traitements: [],
      ListTreatment: [],
      modalTraitement: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
    this.AddEditTreatement = this.AddEditTreatement.bind(this);
    this.handleshowTreatmentModal = this.handleshowTreatmentModal.bind(this);
  }

  AddEditTreatement(data) {
    if (_.isEmpty(data)) {
      this.setState(
        {
          traitement: "PAS_SOUSTRAITEMENT",
          traitements: data,
        },
        () => this.handleSubmit()
      );
    } else {
      this.setState(
        {
          traitement: "SOUSTRAITEMENT",
          traitements: data,
        },
        () => this.handleSubmit()
      );
    }
  }

  toggle() {
    this.props.toggle();
    this.setState({
      readySubmit: false,
      accompagantDepart: "",
      etatRepas: "",
      etatSommeil: "",
    });
  }
  componentDidMount() {
    let kidItem = this.props.kidItem;
    if (notEmpty(kidItem) && !this.props.isUpdate) {
      let tok = localStorage.getItem("token");
      var kidsId = this.props.kidItem.id;
      const response = Service.get(
        `${API}api/enfant/creche/enfants/${kidsId}/dossier-medical/traitements`,
        { headers: { Authorization: `Bearer ${tok}` } }
      );
      response.then((res) => {
        if (!_.isEmpty(res.data)) {
          var finalTreatementList = [];
          finalTreatementList = res.data.traitements.map(function(element) {
            var object = {};
            object.description = element.description;
            object.id = element.id;
            object.idOrdonnance =
              _.isEmpty(element.ordonnance) == true
                ? null
                : element.ordonnance.id;
            object.titre = element.titre;
            return object;
          });
        }
        this.setState({
          ListTreatment: finalTreatementList,
        });
      });
      response.catch((err) => {});

      let array = [];
      let arrayParent, arrayTierce;
      if (
        _.isEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "tierce",
            checked: false,
          };
        });
        array = [...arrayTierce];
      } else if (
        notEmpty(kidItem.liensParente) &&
        _.isEmpty(kidItem.tierceAutorises)
      ) {
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "parent",
            checked: false,
          };
        });
        array = [...arrayParent];
      } else if (
        notEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "tierce",
            checked: false,
          };
        });
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "parent",
            checked: false,
          };
        });
        array = [...arrayParent, ...arrayTierce];
      }
      this.setState({ listOfParents: [...array] });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !this.state.initialized &&
      (this.props.isUpdate || this.props.onlyView) &&
      notEmpty(this.props.arriveeData)
    ) {
      let array = [];
      let selectedParent = {};
      let arriveeData = this.props.arriveeData;
      let kidItem = this.props.kidItem;
      let arrayParent, arrayTierce;
      if (
        _.isEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          return nom === arriveeData.nomTierAutorise &&
            prenom === arriveeData.prenomTierAutorise
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: false,
              };
        });
        array = [...arrayTierce];
      } else if (
        notEmpty(kidItem.liensParente) &&
        _.isEmpty(kidItem.tierceAutorises)
      ) {
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          return nom === arriveeData.nomParent &&
            prenom === arriveeData.prenomParent
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: false,
              };
        });
        array = [...arrayParent];
      } else if (
        notEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          return nom === arriveeData.nomTierAutorise &&
            prenom === arriveeData.prenomTierAutorise
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: false,
              };
        });
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          return nom === arriveeData.nomParent &&
            prenom === arriveeData.prenomParent
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: false,
              };
        });
        array = [...arrayParent, ...arrayTierce];
      }
      let otherSelectedParent = array.find((parent) => parent.checked);
      this.setState({
        initialized: true,
        listOfParents: [...array],
        timeArrivee: moment(arriveeData.dateArrivee),
        etatRepas: arriveeData.etatRepas,
        etatSante: arriveeData.etatSante,
        traitement: (arriveeData.sousTraitement)? 'SOUSTRAITEMENT': 'PAS_SOUSTRAITEMENT',
        etatSommeil: arriveeData.etatSommeil,
        selectedParent: otherSelectedParent,
      });
    }
  }
  handleCheck(event, item) {
    if (!this.props.onlyView) {
      let data = JSON.parse(event.target.value);
      let prevSelect =
        this.state.selectedParent.nom + this.state.selectedParent.prenom ===
        data.nom + data.prenom
          ? {}
          : data;
      let newArray = this.state.listOfParents.map((item) =>
        item.prenom + item.nom === data.prenom + data.nom &&
        item.checked === false
          ? {
              nom: item.nom,
              prenom: item.prenom,
              id: item.id,
              type: item.type,
              checked: true,
            }
          : item.prenom + item.nom === data.prenom + data.nom && item.checked
          ? {
              nom: item.nom,
              prenom: item.prenom,
              id: item.id,
              type: item.type,
              checked: false,
            }
          : {
              nom: item.nom,
              prenom: item.prenom,
              id: item.id,
              type: item.type,
              checked: false,
            }
      );
      this.setState(
        { selectedParent: prevSelect, listOfParents: [...newArray] },
        () => {
          if (
            notEmpty(this.state.selectedParent) &&
            notEmpty(this.state.etatRepas) &&
            notEmpty(this.state.etatSante) &&
            notEmpty(this.state.traitement) &&
            notEmpty(this.state.etatSommeil) &&
            !this.props.readySubmit
          ) {
            this.props.handleReadySubmit();
          } else if (
            _.isEmpty(this.state.selectedParent) &&
            notEmpty(this.state.etatRepas) &&
            notEmpty(this.state.etatSante) &&
            notEmpty(this.state.traitement) &&
            notEmpty(this.state.etatSommeil) &&
            this.props.readySubmit
          ) {
            this.props.handleReadySubmit();
          }
        }
      );
    }
  }

  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.name;
      this.setState(
        {
          [name]: event.target.id,
        },
        () => {
          if (
            notEmpty(this.state.selectedParent) &&
            notEmpty(this.state.etatRepas) &&
            notEmpty(this.state.etatSante) &&
            notEmpty(this.state.traitement) &&
            notEmpty(this.state.etatSommeil) &&
            !this.props.readySubmit
          ) {
            this.props.handleReadySubmit();
          } else if (
            !(
              notEmpty(this.state.selectedParent) &&
              notEmpty(this.state.etatRepas) &&
              notEmpty(this.state.traitement) &&
              notEmpty(this.state.etatSante) &&
              notEmpty(this.state.etatSommeil)
            ) &&
            this.props.readySubmit
          ) {
            this.props.handleReadySubmit();
          }
        }
      );
    }
  };

  handleChangeDate = (date) => {
    if (!this.props.onlyView) {
      this.setState({ timeArrivee: date }, () => {
        if (notEmpty(this.state.timeArrivee) && !this.props.readySubmit) {
          this.props.handleReadySubmit();
        } else if (
          _.isEmpty(this.state.timeArrivee) &&
          this.props.readySubmit
        ) {
          this.props.handleReadySubmit();
        }
      });
    }
  };

  handleshowTreatmentModal = (e) => {
    e.preventDefault();
    if (this.state.traitement === "SOUSTRAITEMENT") {
      this.setState({
        modalTraitement: true,
      });
    } else {
      this.setState({ 
        modalTraitement:false,
      });
      this.handleSubmit();
    }
  };

  handleSubmit() {
    if (
      this.props.readySubmit &&
      this.props.isUpdate &&
      notEmpty(this.state.selectedParent) &&
      notEmpty(this.state.timeArrivee) &&
      notEmpty(this.state.etatRepas) &&
      notEmpty(this.state.etatSante) &&
      notEmpty(this.state.traitement) &&
      notEmpty(this.state.etatSommeil) &&
      !this.props.onlyView
    ) {
      let firstItem = this.state.selectedParent;
      let data =
        firstItem.type === "parent"
          ? {
              accompagantDepart: firstItem.nom + " " + firstItem.prenom,
              etatRepas: this.state.etatRepas,
              etatSommeil: this.state.etatSommeil,
              etatSante: this.state.etatSante,
              sousTraitement:this.state.traitement==="SOUSTRAITEMENT",
              idParent: firstItem.id,
              idTierceAutorise: null,
              observation: "string",
              timeArrivee: moment(this.state.timeArrivee).format(),
            }
          : {
              accompagantDepart: firstItem.nom + " " + firstItem.prenom,
              etatRepas: this.state.etatRepas,
              etatSommeil: this.state.etatSommeil,
              etatSante: this.state.etatSante,
              idParent: null,
              idTierceAutorise: firstItem.id,
              sousTraitement: this.state.traitement==="SOUSTRAITEMENT",
              observation: "string",
              timeArrivee: moment(this.state.timeArrivee).format(),
              traitements: this.state.traitements,
            };
      this.props.updateArriveEvent(
        localStorage.getItem("token"),
        this.props.idEvent,
        data
      );
      this.props.handleSubmit();
    } else if (
      this.props.readySubmit &&
      notEmpty(this.state.selectedParent) &&
      notEmpty(this.state.timeArrivee) &&
      notEmpty(this.state.etatRepas) &&
      notEmpty(this.state.etatSante) &&
      notEmpty(this.state.traitement) &&
      notEmpty(this.state.etatSommeil) &&
      !this.props.onlyView
    ) {
      let firstItem = this.state.selectedParent;
      let data =
        firstItem.type === "parent"
          ? {
              accompagantDepart: firstItem.nom + " " + firstItem.prenom,
              etatRepas: this.state.etatRepas,
              etatSommeil: this.state.etatSommeil,
              etatSante: this.state.etatSante,
              idParent: firstItem.id,
              idTierceAutorise: null,
              observation: "string",
               sousTraitement: this.state.traitement==="SOUSTRAITEMENT",
              timeArrivee: moment(this.state.timeArrivee).format(),
              traitements: this.state.traitements,
            }
          : {
              accompagantDepart: firstItem.nom + " " + firstItem.prenom,
              etatRepas: this.state.etatRepas,
              etatSommeil: this.state.etatSommeil,
              etatSante: this.state.etatSante,
              idParent: null,
              idTierceAutorise: firstItem.id,
              observation: "string",
               // sousTraitement: this.state.sousTraitement,
               sousTraitement: this.state.traitement==="SOUSTRAITEMENT",
              timeArrivee: moment(this.state.timeArrivee).format(),
              traitements: this.state.traitements,
            };
      this.props.postArriveSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
      this.props.handleSubmit();
    }
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.deleteArriveEvent(
      localStorage.getItem("token"),
      this.props.idEvent
    );
  }
  handleStyle() {
    return this.props.readySubmit
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }

  handleCloseModal = () => {
    this.setState({
      modalTraitement: false,
    });
  };
  render() {
    const { modalTraitement } = this.state;
    const { t } = this.props;
    return (
      <form>
        <div
          className="tab-pane  show active"
          id="arrivee-pane"
          role="tabpanel"
          aria-labelledby="arrivee-tab"
        >
          <div className="content">
            <h2 className="mb-2">{t('modal_enfant.arrivee_tab.at_what_time')}</h2>
            <TimePickerCustom 
              isOpen={this.state.isOpen} 
              time={this.state.timeArrivee} 
              handleChangeDate={this.handleChangeDate} 
              onlyView={this.props.onlyView}/>

            <h2 className="mt-4">{t('modal_enfant.arrivee_tab.did_eat')}</h2>
            <div className="row mx-n2 justify-content-center etat-sante px-3">
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="BEAUCOUP"
                  value={this.state.etatRepas}
                  name="etatRepas"
                />
                <label
                  htmlFor="BEAUCOUP"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatRepas === "BEAUCOUP",
                  })}
                >
                  {t('common.yes')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="CORRECTEMENT"
                  value={this.state.etatRepas}
                  name="etatRepas"
                />
                <label
                  htmlFor="CORRECTEMENT"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatRepas === "CORRECTEMENT",
                  })}
                >
                  {t('modal_enfant.arrivee_tab.a_little')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="PEU"
                  value={this.state.etatRepas}
                  name="etatRepas"
                />
                <label
                  htmlFor="PEU"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatRepas === "PEU",
                  })}
                >
                  {t('common.no')}
                </label>
              </div>
            </div>
            <h2 className="mt-3">{t('modal_enfant.arrivee_tab.did_sleep')}</h2>
            <div className="row mx-n2 justify-content-center etat-sante px-3">
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="BIEN"
                  value={this.state.etatSommeil}
                  name="etatSommeil"
                />
                <label
                  htmlFor="BIEN"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatSommeil === "BIEN",
                  })}
                >
                  {t('common.yes')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="NORMAL"
                  value={this.state.etatSommeil}
                  name="etatSommeil"
                />
                <label
                  htmlFor="NORMAL"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatSommeil === "NORMAL",
                  })}
                >
                  {t('modal_enfant.arrivee_tab.a_little')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="MAL"
                  value={this.state.etatSommeil}
                  name="etatSommeil"
                />
                <label
                  htmlFor="MAL"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatSommeil === "MAL",
                  })}
                >
                  {t('common.no')}
                </label>
              </div>
            </div>
            <h2 className="mt-3">{t('modal_enfant.arrivee_tab.is_ok')}</h2>
            <div className="row mx-n2 justify-content-center etat-sante px-3">
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="RIEN_DE_GRAVE"
                  value={this.state.etatSante}
                  name="etatSante"
                />
                <label
                  htmlFor="RIEN_DE_GRAVE"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatSante === "RIEN_DE_GRAVE",
                  })}
                >
                  {t('modal_enfant.arrivee_tab.nothing_to_report')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="A_SURVEILLER"
                  value={this.state.etatSante}
                  name="etatSante"
                />
                <label
                  htmlFor="A_SURVEILLER"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatSante === "A_SURVEILLER",
                  })}
                >
                  {t('modal_enfant.arrivee_tab.to_monitor')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="INQUIETANT"
                  value={this.state.etatSante}
                  name="etatSante"
                />
                <label
                  htmlFor="INQUIETANT"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.etatSante === "INQUIETANT",
                  })}
                >
                  {t('modal_enfant.arrivee_tab.worrying')}
                </label>
              </div>
            </div>

            <h2 className="mt-3">{t('modal_enfant.arrivee_tab.under_treatment')}</h2>
            <div className="row mx-n2 justify-content-center etat-sante px-3">
              <div className="col-md-4 px-2">
                <input
                  onChange={this.handleChange}
                  type="checkbox"
                  className="d-none"
                  id="SOUSTRAITEMENT"
                  checked={this.state.traitement ==="SOUSTRAITEMENT"}
                  name="traitement"
                />
                <label
                  htmlFor="SOUSTRAITEMENT"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.traitement === "SOUSTRAITEMENT",
                  })}
                >
                  {t('common.yes')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  onChange={this.handleChange}
                  type="checkbox"
                  className="d-none"
                  id="PAS_SOUSTRAITEMENT"
                  checked={this.state.traitement === "PAS_SOUSTRAITEMENT"}
                  name="traitement"
                />
                <label
                  htmlFor="PAS_SOUSTRAITEMENT"
                  className={Classnames("btn-white btn-border", {
                    active: this.state.traitement === "PAS_SOUSTRAITEMENT",
                  })}
                >
                  {t('common.no')}
                </label>
              </div>
            </div>

            <h2 className="mt-3">{t('modal_enfant.arrivee_tab.who_picks_up')}</h2>
            <ul className="row mx-n2 list-enfants list-sans-avatar mb-0">
              {this.state.listOfParents.map((item, index) => {
                let itemString = JSON.stringify(item);
                return (
                  <li
                    key={index}
                    value={itemString}
                    className="col-md-4 mb-3 px-2"
                  >
                    <input
                      type="checkbox"
                      checked={item.checked}
                      onChange={(event) => this.handleCheck(event, item)}
                      id={item.nom + item.prenom}
                      value={itemString}
                    />
                    <label
                      className="rounded15 box-shadow"
                      htmlFor={item.nom + item.prenom}
                    >
                      <span className="avatar"></span>
                      <span className="name">{item.prenom}</span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
          {modalTraitement ? (
            <ModalTreatement
              handleCloseModal={this.handleCloseModal}
              kidItem={this.props.kidItem}
              AddEditTreatement={this.AddEditTreatement}
              ListTreatment={this.state.ListTreatment}
            />
          ) : (
            ""
          )}
          <div className="d-flex justify-content-center">
            {this.props.onlyView ? (
              ""
            ) : (
              <button
                type="submit"
                onClick={this.handleshowTreatmentModal}
                className="btn-gradient btn-valid"
                style={this.handleStyle()}
              >
                <IconCheckWhite className="img-fluid" />
                {t('common.validate')}
              </button>
            )}
            {this.props.isUpdate ? (
              <button
                onClick={this.handleEventDelete}
                className="btn-supprimer"
              >
                {t('common.delete')}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    arrivee: state.modals.arrivee,
  };
}

export default connect(mapStateToProps, {
postArriveSimple,
  updateArriveEvent,
  deleteArriveEvent,
})(withTranslation()(Arrivee));
